<template>
    <div class="footer-links">
        <ul className="terms-conditions">
            <li>
                <router-link :to="{name:'privacy-policy'}" > سياسة الخصوصية </router-link>
            </li>
            <li>
                <router-link :to="{name:'size_instructions'}" > سياسة الاسترجاع </router-link>
            </li>
            <li>
                <router-link :to="{name: 'terms-conditions'}" > البنود و الشروط </router-link>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    name: 'FooterLinksComponent'
}
</script>
<style scoped>
.footer-links {
    padding: 1rem 0;
}
.terms-conditions {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 15px 0;
  list-style: none;
}

.terms-conditions li {
  color: #FFFFFF;
  padding: 0 15px;
  position: relative;
}

.terms-conditions li a {
    all: unset;
    cursor: pointer;
    font-size: 1.2rem;
    color:#FFFFFF
}

.terms-conditions li:not(:last-child) {
  border-left: 1px solid #ecf0f1;
}
</style>